module.exports = __webpack_public_path__ + "static/media/Fill.2caee07c.svg";